import { db } from '../../utils/firebase';

export const getAllMovies = async () => {
  const vcdb = db.collection("videos").doc("video_collections").collection("children");
  const querySnapshot = await vcdb.get();

  const movies = [];
  querySnapshot.forEach(doc => {
    const { title, videos, date } = doc.data();
    movies.push({ title, videos, date });
  });

  movies.sort((a, b) => b.date.seconds - a.date.seconds);

  return movies;
}

export const getAllYoutube = async () => {
  const youtubedb = db.collection("videos").doc("youtube").collection("children");
  const querySnapshot = await youtubedb.get();

  const youtube = [];
  querySnapshot.forEach(doc => {
    const { title, intro, video, date } = doc.data();
    youtube.push({ title, intro, video, date });
  });

  youtube.sort((a, b) => b.date.seconds - a.date.seconds);

  return youtube;
}